/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
document.addEventListener("DOMContentLoaded", function(){
  var productInfo = document.querySelector('.Product__InfoWrapper');
  var minHeight = document.querySelector('.Product__Wrapper').offsetHeight;
  var windowW = window.innerWidth;
  productInfo.addEventListener("click", function(e){
    if(windowW > 1007) {
      if(e.target.classList.contains("ui-accordion-header") || e.target.classList.contains("ui-accordion-header-icon")) {
          setTimeout( function() {
              var descHeight = document.querySelector(".Product__Info ").offsetHeight;
            if(descHeight > minHeight) {
              document.querySelector(".Product__Gallery").style.height = descHeight + 'px'; 
            } else {
              document.querySelector(".Product__Gallery").style.height = minHeight + 'px';
            }
          }, 300);
      }
    }
  });
});